<template>
  <div class="advantage_container">
    <div
      class="item_wrapper"
      v-for="(item, index) in infos"
      :key="index"
    >
      <div class="circle" :class="item.className">
        <i class="iconfont" v-html="item.icon"></i>
      </div>
      <div class="title">
        {{ item.title }}
      </div>
      <div class="introduce" v-if="item.introduce">
        {{ item.introduce }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Advantage',
  data () {
    return {
      infos: [{
        icon: '&#xe735;',
        title: '专业性强',
        className: 'bg_color1'
      }, {
        icon: '&#xe728;',
        title: '实战经验丰富',
        className: 'bg_color2'
      }, {
        icon: '&#xe6d3;',
        title: '专业化服务流程',
        className: 'bg_color3'
      }, {
        icon: '&#xe60b;',
        title: '品牌口碑好',
        className: 'bg_color4'
      }, {
        icon: '&#xe608;',
        title: '渠道资源丰富',
        className: 'bg_color5'
      }, {
        icon: '&#xe6d8;',
        title: '售后体系完善',
        className: 'bg_color6'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.advantage_container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .item_wrapper {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 20px 50px;
    .circle {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      margin-bottom: 20px;
      color: #FFF;
      font-size: 46px;
      line-height: 100px;
      text-align: center;
      background-color: $bg-color1;
      .iconfont {
        font-size: 60px;
      }
      &.bg_color1 {
        background-color: $bg-color1;
      }
      &.bg_color2 {
        background-color: $bg-color2;
      }
      &.bg_color3 {
        background-color: $bg-color3;
      }
      &.bg_color4 {
        background-color: $bg-color4;
      }
      &.bg_color5 {
        background-color: $bg-color5;
      }
      &.bg_color6 {
        background-color: $bg-color6;
      }
    }
    .title {
      text-align: center;
      font-size: 16px;
      line-height: 32px;
      letter-spacing: 0px;
      color: #333333;
    }
    .introduce {
      text-align: center;
      font-size: 14px;
      line-height: 32px;
      color: #888888;
    }
  }
}
</style>
